var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
/**
 * API service for Building lookup with pagination and filtering
 */
import api from '@utils/axios';
class BuildingService {
    /**
     * Builds filter query string for building name search
     */
    static buildFilterQuery(filterValue) {
        const params = new URLSearchParams({
            'filter[filters][0][value]': filterValue,
            'filter[filters][0][field]': 'label',
            'filter[filters][0][operator]': 'contains',
            'filter[filters][0][ignoreCase]': 'true',
            'filter[logic]': 'and'
        });
        return params.toString();
    }
    /**
     * Maps API response from snake_case to camelCase and calculates hasMore
     */
    static mapApiResponse(apiResponse, currentPage, pageSize) {
        const currentCount = (currentPage - 1) * pageSize + apiResponse.data.length;
        const hasMore = currentCount < apiResponse.total_count;
        return {
            totalCount: apiResponse.total_count,
            data: apiResponse.data,
            hasMore
        };
    }
    /**
     * Fetches paginated buildings from the API
     */
    static getBuildings(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const queryParams = new URLSearchParams({
                    type: 'building',
                    from_current_tenant: 'true',
                    take: params.take.toString(),
                    skip: params.skip.toString(),
                    page: params.page.toString(),
                    pageSize: params.pageSize.toString()
                });
                // Add filter if provided
                if (params.filter) {
                    const filterQuery = this.buildFilterQuery(params.filter);
                    const filterParams = new URLSearchParams(filterQuery);
                    filterParams.forEach((value, key) => {
                        queryParams.append(key, value);
                    });
                }
                const response = yield api.get(`${this.BASE_URL}?${queryParams.toString()}`);
                return this.mapApiResponse(response.data, params.page, params.pageSize);
            }
            catch (error) {
                console.error('Error fetching buildings:', error);
                throw error;
            }
        });
    }
}
BuildingService.BASE_URL = '/lookup';
export default BuildingService;
